// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__WVhx5","footer":"ChangeClinic_footer__IedEM"};